import gql from 'graphql-tag';
import authFragment from './fragments/authFragment';

export default gql`
  ${authFragment}
  mutation createFacebookMember(
    $token: String
    $cityId: Int
    $promoCode: String
  ) {
    createFacebookMember(
      token: $token
      cityId: $cityId
      promoCode: $promoCode
    ) {
      ...authFragment
    }
  }
`;
